/* eslint-disable indent */
import React from "react";
import styles from "../stylesER.module.scss";

export const BTLModal = ({
  isOpen,
  monthIndex,
  currentYear,
  mesesCompletos,
  salesBTL,
  clientes,
  edificios,
  formatCurrency,
  // Inline editing
  editingBTLId,
  setEditingBTLId,
  tempOtrosCostos,
  setTempOtrosCostos,
  guardarOtrosCostosBTL,
  pais,
  onClose,
}) => {
  if (!isOpen || monthIndex === null) return null;

  const filteredSales = salesBTL.filter((r) => new Date(r.facturafecha).getMonth() === monthIndex);

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <h3>
          BTL y otros - {mesesCompletos[monthIndex]} {currentYear}
        </h3>

        <table className={styles.modalTable}>
          <thead>
            <tr>
              <th>ID</th>
              <th>CLIENTE</th>
              <th>EDIFICIO</th>
              <th style={{ textAlign: "right" }}>IMPORTE BRUTO</th>
              <th style={{ textAlign: "right" }}>% COMISIÓN</th>
              <th style={{ textAlign: "right" }}>COMISIÓN $</th>
              <th style={{ textAlign: "right" }}>OTROS COSTOS</th>
              <th style={{ textAlign: "center" }}>ACCIÓN</th>
            </tr>
          </thead>
          <tbody>
            {filteredSales.map((row) => {
              let buildings = [];
              if (row.buildings) {
                if (typeof row.buildings === "string") {
                  try {
                    buildings = JSON.parse(row.buildings);
                  } catch {
                    buildings = [];
                  }
                } else if (Array.isArray(row.buildings)) {
                  buildings = row.buildings;
                }
              }

              return buildings.map((b, idx) => (
                <tr key={`${row.id}-${idx}`}>
                  {idx === 0 && (
                    <td rowSpan={buildings.length} style={{ textAlign: "left", fontWeight: "600" }}>
                      {row.numeric_id || row.id}
                    </td>
                  )}
                  {idx === 0 && (
                    <td rowSpan={buildings.length} style={{ textAlign: "left", fontWeight: "500" }}>
                      {clientes[row.client_id]?.nombre || "-"}
                    </td>
                  )}
                  <td style={{ textAlign: "left", paddingLeft: "20px", color: "#2c3e50" }}>
                    {edificios[b.id]?.edificio || `Edif. ${b.id}`}
                  </td>
                  <td style={{ textAlign: "right", fontWeight: "600" }}>
                    {row.moneda_dolar
                      ? `US$ ${(b.importe || 0).toLocaleString(pais === "Chile" ? "es-CL" : "es-PE", { maximumFractionDigits: 0 })}`
                      : formatCurrency(b.importe)}
                  </td>
                  <td style={{ textAlign: "right" }}>{Number(b.comision).toFixed(2)}%</td>
                  <td style={{ textAlign: "right", fontWeight: "600", color: "#d32f2f" }}>
                    {formatCurrency((b.importe * Number(b.comision)) / 100)}
                  </td>
                  {idx === 0 && (
                    <>
                      <td rowSpan={buildings.length} style={{ textAlign: "right", fontWeight: "500" }}>
                        {editingBTLId === row.id ? (
                          <input
                            type="number"
                            value={tempOtrosCostos}
                            onChange={(e) => setTempOtrosCostos(e.target.value)}
                            autoFocus
                            style={{ width: "100px", textAlign: "right" }}
                          />
                        ) : (
                          formatCurrency(row.otros_costos || 0)
                        )}
                      </td>
                      <td rowSpan={buildings.length} style={{ textAlign: "center" }}>
                        {editingBTLId === row.id ? (
                          <>
                            <button
                              onClick={() => guardarOtrosCostosBTL(row.id, tempOtrosCostos)}
                              className={styles.btnSaveMini}
                            >
                              Guardar
                            </button>
                            <button
                              onClick={() => {
                                setEditingBTLId(null);
                                setTempOtrosCostos("");
                              }}
                              className={styles.btnCancelMini}
                            >
                              Cancelar
                            </button>
                          </>
                        ) : (
                          <button
                            onClick={() => {
                              setEditingBTLId(row.id);
                              setTempOtrosCostos(row.otros_costos || "");
                            }}
                            className={styles.btnEditMini}
                          >
                            Editar
                          </button>
                        )}
                      </td>
                    </>
                  )}
                </tr>
              ));
            })}
          </tbody>
        </table>

        <div className={styles.modalActions}>
          <button className={styles.btnClose} onClick={onClose}>
            Cerrar
          </button>
        </div>
      </div>
    </div>
  );
};
